import { useState } from 'react';
import { TextButton } from 'seagull';
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import styles from "./TimeActivityActions.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TimeActivityActions = _ref => {
  let {
    showAddAll,
    relationshipId,
    handleAddAllTimeActivities
  } = _ref;
  const {
    logBI
  } = useStoreActions();
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.actions,
    children: [showAddAll ? /*#__PURE__*/_jsx(TextButton, {
      onClick: () => {
        logBI(12015, {
          vendorId,
          userId
        });
        handleAddAllTimeActivities();
      },
      weight: "normal",
      underline: "none",
      "data-testid": "add-all-time-activities",
      children: "Add all"
    }) : /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(RefreshTimeActivities, {
      relationshipId: relationshipId
    })]
  });
};
export const RefreshTimeActivities = _ref2 => {
  let {
    relationshipId
  } = _ref2;
  const [isLoading, setIsLoading] = useState(false);
  const userId = useStore(selectors.user.id);
  const vendorId = useStore(selectors.user.businessId);
  const {
    logBI,
    fetchQboTimeActivities
  } = useStoreActions();
  return /*#__PURE__*/_jsx(TextButton, {
    onClick: () => {
      logBI(12019, {
        vendorId,
        userId
      });
      setIsLoading(true);
      fetchQboTimeActivities(relationshipId).finally(() => setIsLoading(false));
    },
    weight: "normal",
    disabled: isLoading,
    underline: "none",
    "data-testid": "refresh-time-activities",
    children: "Refresh"
  });
};